import { render, staticRenderFns } from "./PurchasePaymentList.vue?vue&type=template&id=68233ddc"
import script from "./PurchasePaymentList.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports